import React from 'react';
import PropTypes from 'prop-types';

import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import BookRating from 'rebook/apps/books/components/BookRating';

import styles from './style.scss';


const USER_AVATAR_WIDTH = 40; // ширина аватара пользователя в блоке отзыва
const USER_AVATAR_HEIGHT = 40; // высота аватара пользователя в блоке отзыва

const BookAuthorReview = ({
  width = USER_AVATAR_WIDTH,
  height = USER_AVATAR_HEIGHT,
  imageUrl, name, ratingText,
  bookRating, isSelfReview = false,
}) => {
  return (
    <div className={styles.author}>
      {!isSelfReview && (
        <div className={styles.authorImage}>
          <CroppedImage
            width={width}
            height={height}
            src={imageUrl}
            alt={name} />
        </div>
      )}
      <div className={styles.information}>
        {!isSelfReview && (
          <div className={styles.authorText}>{name}</div>
        )}
        <div className={styles.rating}>
          <span className={styles.ratingText}>{ratingText}</span>
          <BookRating value={bookRating} />
        </div>
      </div>
    </div>
  );
};

BookAuthorReview.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  isSelfReview: PropTypes.bool,
};

export default BookAuthorReview;
